import { areDescriptionsEqual } from "./areDescriptionsEqual";
import { getFileBaseName } from "./getFileBaseName";

export const groupFilesByBaseName = <T extends { name: string }>(files: T[]): T[][] => {
  const groups: T[][] = [];

  for (const file of files) {
    const baseName = getFileBaseName(file.name);
    const existingGroup = groups.find((group) =>
      areDescriptionsEqual(getFileBaseName(group[0]!.name), baseName),
    );

    if (existingGroup) {
      existingGroup.push(file);
    } else {
      groups.push([file]);
    }
  }

  return groups;
};
